import { deleteNetworkGroup } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { ERROR, SUCCESS } from "@Components/Toast";
import Box from "@mui/material/Box";
import React from "react";
import styles from "./index.module.scss";
export default class Delete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }
    onConfirm = async () => {
        if (!this.props.networkId ||
            !this.props.groupId ||
            !this.props.groupName ||
            this.state.isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        try {
            await deleteNetworkGroup(this.props.networkId, this.props.groupId, this.props.isSync);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Country group deleted successfully.",
            });
        }
        catch (error) {
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to delete country group.",
            });
            console.error("Failed to delete country group", error);
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    deletePopup = (close) => {
        return (React.createElement(Card, { className: styles.deletePopup },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, "Delete group"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("p", null,
                    "Are you sure you want to delete",
                    " ",
                    React.createElement("span", null, this.props.groupName),
                    "?")),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { click: this.onConfirm, disabled: this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("CONFIRM")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.deletePopup, onClose: () => this.props.close() }));
    }
}
